import script from "./CompanyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyView.vue?vue&type=style&index=0&id=6df8479f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df8479f"]])

export default __exports__